module.exports = __webpack_public_path__ + "static/media/new-address-caution.2fa2c6d2.svg";